"use client"

import React from 'react';
import { useSearchParams } from 'next/navigation';
import SaveSearchButton from './SaveSearchButton';

const ActionBar = () => {
  const searchParams = useSearchParams();
  const currentSort = searchParams?.get("sort");
  const isDescending = currentSort?.includes("dsc");

  return (
    <div className="fixed z-20 h-18 flex items-center space-x-2 w-full p-2 lg:hidden bg-white">
      <SaveSearchButton size='small' />
      
      <label htmlFor={'sort'} className="btn btn-outline btn-primary flex-[4]  sm:flex-[2] flex-grow rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 text-primary ${isDescending ? 'transform rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
        </svg>
        <span className="text-primary font-medium">Sort</span>
      </label>
      
      <label htmlFor={'filter'} className="btn btn-primary flex-[2] sm:flex-[4] rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-base-100" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
        <span className="text-base-100 font-medium">Filter</span>
      </label>
    </div>
  );
};

export default ActionBar;